/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * @emails react-core
 */

import StickyResponsiveSidebar from './StickyResponsiveSidebar';

export default StickyResponsiveSidebar;
